import { useSelector } from "react-redux";
import { BsFillStopwatchFill } from "react-icons/bs";
import { MdPushPin } from "react-icons/md";
import { IoTennisball } from "react-icons/io5";
import { GiSoccerBall } from "react-icons/gi";
import { BiSolidCricketBall } from "react-icons/bi";
import { useEffect, useState } from "react";
import { FaChevronRight, FaChevronUp } from "react-icons/fa";
import { TiArrowRightThick } from "react-icons/ti";
import { getLegues } from "../../../AsianExchangeSrc/api";
import SportsMatchesList from "../../components/SportsMatchesList";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const sportsList = [
  {
    sportName: "Cricket",
    sportId: 4
  },
  {
    sportName: "Tennis",
    sportId: 2

  },
  {
    sportName: "Soccer",
    sportId: 1

  },
  {
    sportName: "Horse Racing",
    sportId: 0,
    style: "navigate",
    href: "/horseRacing"
  },
  {
    sportName: "Greyhound Racing",
    sportId: 0,
    style: "navigate",
    href: "/greyhoundRacing"
  },
  {
    sportName: "Basketball",
    sportId: 0,
    style: "navigate",
    href: "/basketball"
  },

  {
    sportName: "Lottery",
    sportId: 0,
    style: "navigate",
    href: "/lottery?live-casino=true&q1=All&q2=lottery"
  },
  {
    sportName: "Live Casino",
    sportId: 0,
    style: "navigate",
    href: "/live-casino?live-casino=true&q1=All&q2=casino"
  },
]

function QuickLinks() {
  const navigate = useNavigate()
  const headerColor = useSelector(state => state?.site?.siteDetails?.headerColor);
  const [activeSport, setActiveSport] = useState(null);
  const [activeLeague, setActiveLeague] = useState(null);

  return (
    <div className="w-full flex flex-col pb-8"
      style={{ maxHeight: "calc(100vh - 56px - 56px)", overflowY: "auto" }}
    >
      <div className={`w-full h-full min-h-9 flex flex-row justify-center items-center text-white`}
        style={{
          background: "linear-gradient(-180deg, #2E4B5E 0%, #243A48 82%)"
        }}
      >
        Quick Links
      </div>
      <div className="w-full min-h-19 max-h-19 flex flex-row justify-start flex-wrap text-white" style={{ backgroundColor: "#14213D" }}>
        <div
          className="flex flex-col border-r justify-start items-center w-1/5 min-h-19  px-1 py-4"
          onClick={() => { navigate("/inplay") }}
        >
          <BsFillStopwatchFill size={30} />
          <p> Inplay </p>
        </div>
        <div
          className="flex flex-col border-r justify-start items-center w-1/5 min-h-19  px-1 py-4"
          onClick={() => { navigate("/multi-market") }}
        >
          <MdPushPin size={30} />
          <p className="text-center leading-none"> Multi Markets </p>
        </div>
        <div
          className="flex flex-col border-r justify-start items-center w-1/5 min-h-19 px-1 py-4"
          onClick={() => { setActiveSport("Cricket"); setActiveLeague(null) }}
        >
          <BiSolidCricketBall size={30} />
          <p> Cricket </p>
        </div>
        <div
          className="flex flex-col border-r justify-start items-center w-1/5 min-h-19 px-1 py-4"
          onClick={() => { setActiveSport("Tennis"); setActiveLeague(null) }}

        >
          <IoTennisball size={30} />
          <p> Tennis </p>
        </div>
        <div
          className="flex flex-col justify-start items-center w-1/5 min-h-19 px-1 py-4"
          onClick={() => { setActiveSport("Soccer"); setActiveLeague(null) }}

        >
          <GiSoccerBall size={30} />
          <p> Soccer </p>
        </div>

      </div>
      <div className={`w-full h-full min-h-9 flex flex-row justify-center items-center font-semibold text-white`}
        style={{
          // backgroundColor: headerColor?.start,
          background: "linear-gradient(-180deg, #2E4B5E 0%, #243A48 82%)"

        }}
      >
        {!activeSport ? "Sports" : activeSport} {!activeLeague ? null : ` > ${activeLeague}`}
      </div>
      {
        sportsList.map(({ sportName, sportId, style, href }) => {
          const isActive = activeSport === sportName
          return (
            <div>
              <div
                className="w-full min-h-11 flex flex-row justify-between items-center border font-semibold p-2 text-[#2789CE]"
                onClick={() => { if(style==="navigate"){navigate(href)} else {setActiveSport(isActive ? null : sportName); setActiveLeague(null)} }}
                
              >
                <p className="text-md text-[#2789CE]" >{sportName}</p>
                <span className="border rounded-md h-7 w-6 flex flex-row justify-center items-center text-black dark:text-white">
                  {/* {isActive ? <FaChevronUp size={16} /> : <FaChevronRight size={16} />
                  }
                   */}
                  <motion.div
                    animate={{ rotate: isActive ? -90 : 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <FaChevronRight size={16} />
                  </motion.div>
                </span>
              </div>
              <AnimatePresence initial={false}>
                {isActive && (
                  <motion.div
                    key="leagueSection"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="py-1 pr-2 ml-2 border-b text-sm font-semibold text-black dark:text-white">
                      {`${sportName} Leagues`}
                    </div>
                    <SportsLeagues
                      sportId={sportId}
                      sportName={sportName}
                      selectedLeague={activeLeague}
                      setSelectedLeague={setActiveLeague}
                    />
                  </motion.div>
                )}
              </AnimatePresence>

            </div>
          )
        })
      }

    </div>
  )
}

export const SportsLeagues = ({ sportId, sportName, selectedLeague, setSelectedLeague }) => {
  const [leagues, setLeagues] = useState({ 4: [], 1: [], 2: [] })
  const matchList = useSelector(state => state?.matches?.[sportName.toLowerCase()]?.matches?.data);

  useEffect(() => {
    const fetchLeagues = async () => {
      if (sportId > 0 && sportId < 5) {
        const leagueResponse = await getLegues(sportId);
        if (leagueResponse.success && Array.isArray(leagueResponse.data.data)) {
          setLeagues((prev) => ({ ...prev, [sportId]: leagueResponse.data.data }))
        }

      }

    }

    fetchLeagues()

    return () => {

    }
  }, [sportId])

  return (
    <div className="flex flex-col">
      {
        leagues && leagues?.[sportId]?.map(({ competitionName, competitionId }) => {
          const isActive = selectedLeague === competitionName
          return (
            <div key={competitionName}>
              <div className="ml-4 border-b pr-2 py-1 min-h-7 text-[#2789CE]" onClick={() => setSelectedLeague(competitionName)} >

                <p
                  className="text-md flex flex-row items-center" style={{ fontWeight: isActive ? 700 : 500 }}
                >
                  <span className="text-[#2789CE] mr-1"><TiArrowRightThick /></span>  {competitionName}
                </p>
              </div>
              <AnimatePresence initial={false}>
                {isActive && (
                  <motion.div
                    key="matches"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden ml-4 bg-offwhite dark:bg-dark-bg"
                  >
                    <SportsMatchesList sportId={sportId} compactDesign={true} matchesList={matchList.filter(m => m.competitionId === competitionId)} />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          )
        })
      }
    </div>
  )
}


export default QuickLinks
